import { Component, inject } from '@angular/core';
import { LoadingStore } from '@app/core/store/loading-store';
import { ProgressSpinnerModule } from '@openng/optimus-ui/progressspinner';

@Component({
  selector: 'app-loader',
  imports: [ProgressSpinnerModule],
  templateUrl: './loader.html',
  styleUrl: './loader.scss',
})
export class Loader {
  loadingStore = inject(LoadingStore);
}
